import { NamedError } from "../../../utils/Errors"

export class AuthError extends NamedError<AuthErrors> {}

export enum AuthErrors {
    UnableToAuthenticate = "UnableToAuthenticate",
    UnableToFetchToken = "UnableToFetchToken",
    AuthenticationError = "AuthenticationError",
    CannotGetAuthContext = "CannotGetAuthContext"
}

/**
 * This function checks whether the given error is an auth related error.
 *
 * Special case - Though we throw an AuthError in ProdAuthenticationProvider.GetAccessToken, this gets caught
 * in GraphClientInitOptions. The graph error callback that we call there then remaps that
 * AuthError into some other generic exception that has an error code of AuthErrors.UnableToFetchToken.
 * So we need to check error.code below directly as well
 * @param error The error instance to use for evaluating whether this is an auth error
 */
export function IsAuthError(error: any) {
  if (error instanceof AuthError && (error.name == AuthErrors.UnableToAuthenticate || error.name == AuthErrors.UnableToFetchToken)) {
      return true;
  }

  if (typeof error !== "undefined" && typeof error.code !== "undefined" && (error.code == AuthErrors.UnableToFetchToken || error.code == AuthErrors.AuthenticationError || error.code == AuthErrors.CannotGetAuthContext)) {
    return true;
  }

  return false;
}

export function IsCannotGetAuthContextError(error: any) {
  if (typeof error !== "undefined" && typeof error.code !== "undefined" && ( error.code == AuthErrors.CannotGetAuthContext)) {
    return true;
  }

  return false;
}
